import React from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { Grid } from '@mui/material'
import { setFormError, setExaminerDetail } from 'src/redux/slices/eExamination'
import DatePicker from 'src/components/DatePicker'
import { getError } from './event'
import dayjs from 'dayjs'

const DateYearSelect = ({ index, obj, label, disabled, required = false }) => {
  const dispatch = useDispatch()
  const { value, startYear, endYear, formError, showFormError } = useSelector(
    (state) => ({
      value: state.eExamination.examiners[index][obj],
      startYear: state.eExamination.examiners[index].startYear,
      endYear: state.eExamination.examiners[index].endYear,
      formError: state.eExamination.formError[index],
      showFormError: state.eExamination.showFormError,
    }),
    shallowEqual
  )

  const now = dayjs()
  const minYearDate = dayjs('1900-01-01')

  // กำหนด min/max ตาม field ที่ส่งเข้ามา
  const minDate =
    obj === 'startYear'
      ? minYearDate
      : startYear
      ? dayjs(startYear, 'YYYY').startOf('year')
      : minYearDate

  const maxDate =
    obj === 'startYear'
      ? endYear
        ? dayjs(endYear, 'YYYY').endOf('year')
        : now.endOf('year')
      : now.endOf('year')

  return (
    <Grid item sm={6} xs={12}>
      <DatePicker
        id={`${obj}-${index}`}
        labelText={label}
        value={value && /^\d{4}$/.test(value) ? dayjs(value, 'YYYY') : null}
        required={required}
        placeholder="YYYY"
        hideTextError={!showFormError}
        textError={getError(formError, obj)}
        format={'yyyy'}
        views={['year']}
        minDate={minDate}
        maxDate={maxDate}
        boxSx={{
          '& .MuiTextField-root': {
            background: '#FFFFFF',
            '& input.Mui-disabled': {
              WebkitTextFillColor: 'rgba(0, 0, 0, 0.70)',
            },
            '& svg': {
              color: '#00008F',
            },
          },
        }}
        onChange={(e) => {
          if (!e || !dayjs(e).isValid()) {
            dispatch(setExaminerDetail({ index, obj, value: '' }))
            return
          }
          const year = dayjs(e).format('YYYY')
          // บล็อกปีที่ไม่ใช่ช่วง 2000-2099 (หรือที่ต้องการ)
          if (!/^(19|20)\d{2}$/.test(year)) {
            dispatch(setFormError({ index, obj, error: 'ปีไม่ถูกต้อง' }))
            dispatch(setExaminerDetail({ index, obj, value: '' }))
            return
          }

          const yearNum = parseInt(year, 10)

          if (yearNum >= 1900 && yearNum <= new Date().getFullYear()) {
            dispatch(setExaminerDetail({ index, obj, value: year }))
          }
        }}
        disabledInput={disabled}
      />
    </Grid>
  )
}

export default DateYearSelect
